import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './authShared.css';
import { useVerifyOTP } from '../hooks/useVerifyOTP';
import { useTheme } from '../ThemeContext';
import logoLight from '../images/QuiblyLight.png';
import logoDark from '../images/QuiblyDark.png';

const Verify = () => {
  const { darkMode } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const initialEmail = location.state?.email || '';
  const [email, setEmail] = useState(initialEmail);
  const [otp, setOtp] = useState('');
  const [resent, setResent] = useState(false);
  const { verifyOTP, resendOTP, isLoading, error } = useVerifyOTP();

  const handleVerify = async (e) => {
    e.preventDefault();
    const result = await verifyOTP(email, otp);
    if (result) {
      navigate('/login');
    }
  };

  const handleResend = async () => {
    const result = await resendOTP(email);
    if (result) {
      setResent(true);
    }
  };

  return (
    <div className={`authPage ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="authCard">
        <Link to="/" className="authLogoLink">
          <img src={darkMode ? logoDark : logoLight} alt="Quibly" className="authLogo" />
        </Link>

        <h1 className="authTitle">Verify your email</h1>
        <p className="authSubtitle">
          We sent a verification code to your inbox. Enter it below to activate your account.
        </p>

        <form className="authForm" onSubmit={handleVerify}>
          <div className="authField">
            <label className="authLabel" htmlFor="verify-email">Email</label>
            <input
              id="verify-email"
              className="authInput"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              autoComplete="email"
              required
            />
          </div>

          <div className="authField">
            <label className="authLabel" htmlFor="verify-otp">Verification code</label>
            <input
              id="verify-otp"
              className="authInput authOtpInput"
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="000000"
              inputMode="numeric"
              autoComplete="one-time-code"
              required
            />
          </div>

          {error && <div className="authError">{error}</div>}
          {resent && !error && (
            <div className="authSuccess">A new code has been sent to your email.</div>
          )}

          <button type="submit" className="authBtn solid" disabled={isLoading}>
            {isLoading ? 'Verifying…' : 'Verify account'}
          </button>

          <button type="button" className="authBtn ghost" onClick={handleResend} disabled={isLoading}>
            Resend code
          </button>
        </form>

        <p className="authFooter">
          Already verified? <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
};

export default Verify;
